import React, { act, useContext, useEffect, useState } from "react";
import ShopFilter from "../components/MegaShop/ShopFilter";
import Catalog from "../components/MegaShop/Catalog";
import "../css/megashop.css";
import {
  dinosaurGrowths,
  dinosaurTypes,
  megaShopTypes,
  pageNames,
} from "../utils/consts";
import ComponentContainer from "../components/ComponentContainer";

import { observer } from "mobx-react-lite";
import {
  catalogData,
  legacyCatalogCategoriesEng,
} from "../utils/megaShopItemsData";
import userStore from "../store/userStore";
import { megaShopStore } from "../store/megaShopStore";
import megaShopApi from "../api/megaShopApi";
import basketApi from "../api/basketApi";
import basketStore from "../store/basketStore";
import { fetchWithAbort } from "../utils/fetchWithAbort";

const MegaShop = () => {
  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      userStore.setPageName(pageNames.MegaShop);
      try {
        let data = await fetchWithAbort(
          (signal) => megaShopApi.getEvrimaData(signal),
          signal
        );
        data = data.filter(
          (item) => item.category !== legacyCatalogCategoriesEng.items
        );
        console.log(data);
        megaShopStore.setData(data);
        megaShopStore.setVisibleData(data);
      } catch (err) {
        console.error(err);
      }
    })();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="megashop-page">
      <ComponentContainer className="navigation">
        <ShopFilter />
        <Catalog />
      </ComponentContainer>
    </div>
  );
};

export default observer(MegaShop);
